import React from "react";
import { Link } from "react-router-dom";
import { RouteEndpoints } from "../services/route.service";

import exploreBundlesBg from "../assets/images/pages/explore-bundles-webapp-bg.svg";
import exploreBundlesBannerImage from "../assets/images/pages/explore-bundles-banner-image.png";

const bannerStyle = {
  backgroundColor: "#0f2747",
  backgroundImage: `url(${exploreBundlesBg})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat" as const,
  borderRadius: "20px",
};

const buttonStyle = {
  fontSize: "16px",
  fontWeight: 500,
  backgroundColor: "#DF6438",
  borderRadius: "8px",
  padding: "8px 28px",
  fontFamily: "Poppins",
};

const ExploreBundlesBanner = () => {
  return (
    <>
      {/* Desktop: original layout (lg and up) */}
      <div
        className="explore-bundles-banner d-none d-lg-flex align-items-center p-4 p-lg-5"
        style={bannerStyle}
      >
        <div className="d-flex flex-column gap-3" style={{ width: "50%" }}>
          <h2
            className="text-white mb-0"
            style={{
              fontSize: "2.625rem",
              fontWeight: 500,
              lineHeight: 1.2,
            }}
          >
            Explore Class
            <br />
            Bundles
          </h2>
          <p
            className="text-white mb-0"
            style={{
              fontSize: "16px",
              fontWeight: 400,
              opacity: 0.95,
            }}
          >
            Get a bunch of related courses together at once for less.
          </p>
          <Link
            to={RouteEndpoints.CLASS_BUNDLES}
            className="btn text-white text-decoration-none d-inline-flex align-items-center align-self-start"
            style={buttonStyle}
          >
            Start learning {">"}
          </Link>
        </div>
        <img
          src={exploreBundlesBannerImage}
          alt="Explore class bundles"
          style={{
            width: "50%",
            height: "auto",
            objectFit: "contain",
          }}
        />
      </div>

      {/* Mobile: stacked layout (below lg) */}
      <div
        className="explore-bundles-banner d-flex d-lg-none flex-column align-items-center p-4"
        style={bannerStyle}
      >
        <h2
          className="text-white mb-0 text-center"
          style={{
            fontSize: "1.75rem",
            fontWeight: 500,
            lineHeight: 1.2,
          }}
        >
          Explore Class
          <br />
          Bundles
        </h2>
        <p
          className="text-white mb-0 text-center mt-2"
          style={{
            fontSize: "16px",
            fontWeight: 400,
            opacity: 0.95,
          }}
        >
          Get a bunch of related courses together at once for less.
        </p>
        <img
          src={exploreBundlesBannerImage}
          alt="Explore class bundles"
          className="mt-3"
          style={{
            width: "92%",
            maxWidth: "360px",
            height: "320px",
            objectFit: "contain",
          }}
        />
        <Link
          to={RouteEndpoints.CLASS_BUNDLES}
          className="btn text-white text-decoration-none w-100 mt-3 d-flex align-items-center justify-content-center"
          style={buttonStyle}
        >
          Start learning {">"}
        </Link>
      </div>
    </>
  );
};

export default ExploreBundlesBanner;
